import { render } from "./SearchProductModal.vue?vue&type=template&id=792d7f16"
import script from "./SearchProductModal.vue?vue&type=script&lang=js"
export * from "./SearchProductModal.vue?vue&type=script&lang=js"

import "./SearchProductModal.vue?vue&type=style&index=0&id=792d7f16&lang=css"
script.render = render

export default script